import React, { useState } from 'react';
import SearchableSelect from '../common/searchable-select';

const AssignModal = ({ messengers, onClose, onConfirm }) => {
    const [messengerId, setMessengerId] = useState('');

    const messengerOptions = messengers.map((m) => ({
        value: String(m.id),
        label: `${m.name} ${m.surname}`,
    }));

    return (
        <div className="return-modal-overlay" onClick={onClose}>
            <div className="return-modal" onClick={(e) => e.stopPropagation()}>
                <h2 className="return-modal__title">มอบหมายงานให้ Messenger</h2>
                <p className="return-modal__subtitle">กรอกรายละเอียดในคำขอใช้บริการ</p>
                <div className="return-modal__field">
                    <label className="return-modal__label">เลือก Messenger</label>
                    <SearchableSelect
                        id="assign-messenger"
                        name="messenger"
                        value={messengerId}
                        onChange={(e) => setMessengerId(e.target.value)}
                        options={messengerOptions}
                        placeholder="Messenger name"
                    />
                </div>
                <div className="return-modal__footer">
                    <button className="return-modal__btn return-modal__btn--cancel" onClick={onClose}>Cancel</button>
                    <button
                        className="return-modal__btn return-modal__btn--submit"
                        onClick={() => onConfirm(messengerId)}
                        disabled={!messengerId}
                    >
                        Assign
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AssignModal;